import { IconProps } from "@/types/types";

export default function ThumbUp({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5492 0.916672C12.1557 0.916672 11.79 1.11937 11.5814 1.45304L7.33333 8.25001V19.25H17.2002C17.8947 19.25 18.5295 18.8577 18.8401 18.2365L20.6962 14.5242C20.9508 14.0151 21.0833 13.4536 21.0833 12.8844V9.16667C21.0833 8.15415 20.2626 7.33334 19.25 7.33334H13.2917L14.223 2.98716C14.4513 1.92153 13.639 0.916672 12.5492 0.916672Z" fill="currentColor" />
            <path d="M1.375 9.16667C1.375 8.66042 1.78541 8.25001 2.29167 8.25001H5.04167V19.25H2.29167C1.78541 19.25 1.375 18.8396 1.375 18.3333V9.16667Z" fill="currentColor" />
        </svg>
    )
}

